import { FoldersColumns, useFoldersColumns } from "./columns";
import DataTableCompanies from "./data-table";
import { useSelector } from "react-redux";

import { clientSelector } from "@/redux/clients/clients.selector";
import { TableSkeleton } from "@/components/ui/loading";

const FoldersTable = () => {
  const { foldersSpecific, loading } = useSelector(clientSelector).ui;
  const columnsFolders = useFoldersColumns();
  const dataFolders =
    (foldersSpecific &&
      foldersSpecific.carpetas.length > 0 &&
      foldersSpecific.carpetas.map((folder) => ({
        nombre: foldersSpecific.nombre,
        carpeta: folder.numeroCarpeta,
        nroDua: folder.dua.nroDua,
        refCliente: folder.refCliente,
        canal: folder.dua.canal,
        facturas: folder.facturas,
        facturasComerciales: folder.facturasComerciales,
        fechaNumerado: folder.dua.fechaNumerado,
        idCliente: foldersSpecific.id,
      }))) ||
    [];

  return (
    <div className="container pb-2 min-w-full">
      {loading ? (
        <TableSkeleton rows={8} columns={6} />
      ) : (
        <DataTableCompanies
          columns={columnsFolders}
          data={dataFolders as FoldersColumns[]}
        />
      )}
    </div>
  );
};

export default FoldersTable;
